import React from "react";
import { Form, FormControl, FormGroup, FormLabel, InputGroup } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { getError } from "../../shared/utils";

const useOptionalFormContext = () => {
    const form = useFormContext()
    if (form) {
        return form
    } else {
        return {
            register: () => ({}),
            formState: { errors: {} },
        }
    }
};

const Input = ({ label, name, rules, type = "text", placeholder = "", rows = 0, leftElement, rightElement, formControlProps }) => {
    const {
        register,
        formState: { errors },
    } = useOptionalFormContext();

    return (
        <FormGroup className="mb-3">
            {label && <FormLabel htmlFor={name}>{label}{rules?.required && <span className="text-danger ms-1">*</span>}</FormLabel>}
            <InputGroup hasValidation>
                {leftElement && <InputGroup.Text>{leftElement}</InputGroup.Text>}
                <FormControl
                    id={name}
                    type={type}
                    placeholder={placeholder}
                    {...register(name, rules)}
                    isInvalid={name && !!getError(errors, name)}
                    as={rows ? "textarea" : "input"}
                    rows={rows ?? 1}
                    {...formControlProps}
                />
                {rightElement && <InputGroup.Text className={"p-1"}  >{rightElement}</InputGroup.Text>}
                <Form.Control.Feedback type="invalid">
                    {name && getError(errors, name)?.message}
                </Form.Control.Feedback>
            </InputGroup>
        </FormGroup>
    );
};

export default Input;
